'use strict';

const angular = require('angular');

module.exports = angular.module('spinnaker.gce.securityGroup.reader', [
])
  .factory('gceSecurityGroupReader', function () {

    function resolveIndexedSecurityGroup(indexedSecurityGroups, container, securityGroupId) {
      return indexedSecurityGroups[container.account].global[securityGroupId];
    }

    return {
      resolveIndexedSecurityGroup: resolveIndexedSecurityGroup,
    };
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/google/src/securityGroup/securityGroup.reader.js